(function () {
  'use strict';

  function updateCartCount() {
    var badge = document.querySelector('[data-lamp-top-cart-count]');
    if (!badge) return;

    fetch('/cart.js')
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        badge.textContent = cart.item_count;
        badge.classList.toggle('is-hidden', cart.item_count === 0);
      })
      .catch(function () {
        /* si falla, dejamos el número que ya vino renderizado por Liquid */
      });
  }

  // Se refresca cuando el selector "Combiná y ahorrá" agrega productos.
  document.addEventListener('lamp:cart-updated', updateCartCount);

  // También se refresca con el pub/sub nativo de Dawn, si está disponible
  // (por ejemplo cuando se usa el botón normal de "Agregar al carrito").
  document.addEventListener('DOMContentLoaded', function () {
    if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, updateCartCount);
    }
  });
})();